module.exports = __webpack_public_path__ + "static/img/about-head.3a9a6491.png";